import { JupiterTheme, MockHook } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import useCustomLogoLogic, {
  CustomLogoComponentProps,
} from './useCustomLogoLogic';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    customLogoRoot: {
      display: 'flex',
      flexDirection: 'row',
      position: 'relative',
    },
    j1LogoRoot: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },

    accountLogo: {
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      margin: theme.spacing(0, 2),
      backgroundColor: theme.palette.background.dark,
      width: 35,
      height: 35,
    },
    j1Logo: {
      marginLeft: theme.spacing(2),
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    textContent: {
      height: 32,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    poweredByText: {
      fontSize: 9,
      color: theme.palette.common.white,
    },
    accountNameText: {
      fontSize: 16,
      color: theme.palette.common.white,
    },
    accountNameWithJ1Logo: {
      fontSize: 16,
      color: theme.palette.common.white,
      marginLeft: theme.spacing(2),
    },
    fallbackContainer: {
      marginRight: theme.spacing(2),
    },
    removalOfDeadImage: {
      display: 'none',
    },
  });
});

export const CustomLogoComponent = ({
  companyLogoURI,
  accountName,
  hasAccountLogoFeature,
  children,
  imageLoadFailure,
  handleImageHasFailedToLoad,
  handleSuccessfulLoadOfImage,
}: CustomLogoComponentProps) => {
  const classes = useStyles();

  return hasAccountLogoFeature && companyLogoURI ? (
    <div className={classes.customLogoRoot}>
      {imageLoadFailure && (
        <span className={classes.fallbackContainer}>{children}</span>
      )}

      <img
        onLoad={handleSuccessfulLoadOfImage}
        onError={handleImageHasFailedToLoad}
        className={
          imageLoadFailure ? classes.removalOfDeadImage : classes.accountLogo
        }
        src={`${companyLogoURI}`}
      />

      <div className={classes.textContent}>
        <Typography
          component="span"
          variant="body1"
          className={classes.accountNameText}
        >
          {accountName}
        </Typography>
        <Typography
          component="span"
          variant="body1"
          className={classes.poweredByText}
        >
          Powered by JupiterOne
        </Typography>
      </div>
    </div>
  ) : (
    <div className={classes.j1LogoRoot}>
      {children}
      <Typography
        component="span"
        variant="body1"
        className={classes.accountNameWithJ1Logo}
      >
        {accountName}
      </Typography>
    </div>
  );
};

export default MockHook.withHookHoc(CustomLogoComponent, useCustomLogoLogic);
